import React, { useCallback, useRef, useState } from "react";
import { useSpeechSynthesisContext } from "../../../../hooks/SpeechSynthesisContext";

function AnnouncementStatusIndicator() {
  const { enableSpeechSynthesis, isSpeechEnabled } = useSpeechSynthesisContext();
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  const [isEnabling, setIsEnabling] = useState(false);
  const dingAudioRef = useRef(null);

  const isUnlocked = audioUnlocked || isSpeechEnabled;

  const handleTap = useCallback(async () => {
    if (isEnabling || isUnlocked) return;
    setIsEnabling(true);

    try {
      if (!dingAudioRef.current) {
        dingAudioRef.current = new Audio("/ding.mp3");
      }

      const dingPlayed = await dingAudioRef.current
        .play()
        .then(() => true)
        .catch(() => false);
      dingAudioRef.current.pause();
      dingAudioRef.current.currentTime = 0;

      const speechEnabled = await enableSpeechSynthesis();

      if (dingPlayed || speechEnabled) {
        setAudioUnlocked(true);
      }
    } catch (error) {
      console.warn("Failed to enable announcements:", error);
    } finally {
      setIsEnabling(false);
    }
  }, [enableSpeechSynthesis, isEnabling, isUnlocked]);

  const statusColor = isUnlocked ? "#28a745" : "#dc3545";
  const statusBg = isUnlocked ? "#d4edda" : "#f8d7da";
  const statusText = isUnlocked ? "#155724" : "#721c24";
  const label = isEnabling
    ? "Enabling..."
    : isUnlocked
      ? "Announcements on"
      : "Tap to enable announcements";

  return (
    <button
      type="button"
      onClick={handleTap}
      disabled={isEnabling || isUnlocked}
      title={label}
      aria-label={label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        padding: "0.35rem 0.65rem",
        borderRadius: "999px",
        border: `2px solid ${statusColor}`,
        backgroundColor: statusBg,
        color: statusText,
        cursor: isUnlocked ? "default" : isEnabling ? "wait" : "pointer",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
        fontSize: "0.75rem",
        fontWeight: 600,
        lineHeight: 1,
        verticalAlign: "middle",
      }}
    >
      <i
        className={`bi ${isUnlocked ? "bi-volume-up-fill" : "bi-volume-mute-fill"}`}
        style={{ fontSize: "0.95rem" }}
        aria-hidden
      />
      <span
        style={{
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          backgroundColor: statusColor,
          flexShrink: 0,
        }}
        aria-hidden
      />
    </button>
  );
}

export default AnnouncementStatusIndicator;
